import { render } from "./SpecCart.vue?vue&type=template&id=632b2f33"
import script from "./SpecCart.vue?vue&type=script&lang=js"
export * from "./SpecCart.vue?vue&type=script&lang=js"

import "./SpecCart.vue?vue&type=style&index=0&id=632b2f33&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__